export default () => ({
  isOpenLeft: false,
  isOpenRight: false,
  menu: null,
  subMenu: 1,
  activeButton: null,
  mouseEnter(index, side) {
    this.menu = index;
    this.activeButton = index;
    this.subMenu = 1;
    if (side === "left") {
      this.isOpenLeft = true;
    }
    if (side === "right") {
      this.isOpenRight = true;
    }
    this.$dispatch("bg-toggle", true);
  },
  mouseLeave(side) {
    if (side === "left") {
      this.isOpenLeft = false;
    }
    if (side === "right") {
      this.isOpenRight = false;
    }
    this.activeButton = null;

    this.$dispatch("bg-toggle", false);
  },
  setSubMenu(index) {
    this.subMenu = index;
  },
});
